<template>
  <div class="product-list-slider">
    <sib-carousel
      v-if="products && products.length"
      :items="products"
      :options="carouselOptions"
    >
      <template #default="{ item }">
        <ProductListItem
          :is-lazy-loading-image="true"
          :product="item"
          :referer="referer"
          :showFirstMockupImage="showFirstMockupImage"
          :showWishlistIcon="showWishlistIcon"
          @item-click="$emit('item-click')"
          @error-image="$emit('error-image', item.handle)"
        />
      </template>
    </sib-carousel>
  </div>
</template>

<script setup lang="ts">
import { CarouselOptions, NullOrType, Product } from '@/types'
import ProductListItem from './ProductListItem.vue'

interface ProductListProp {
  products?: NullOrType<Product>[]
  referer?: string
  showFirstMockupImage?: boolean
  showWishlistIcon?: boolean
}

const props = withDefaults(defineProps<ProductListProp>(), {
  products: () => [],
  showFirstMockupImage: false,
  showWishlistIcon: false,
})

const carouselOptions: CarouselOptions = {
  center: false,
}
</script>

<style lang="scss">
.product-list-slider {
  .carousel {
    --carousel-slide-width: calc((100% - 1em) / 2 - 1px);

    &__slide {
      margin-right: 1em;
      margin-left: 1px;
    }

    &__button.is-prev,
    &__button.is-next {
      border-radius: 50%;
      svg {
        width: 1rem;
      }
      top: 38%;
    }
    @include media-md-up {
      --carousel-slide-width: calc((100% - 2em) / 3 - 1px);
    }

    @include media-lg-up {
      --carousel-slide-width: calc((100% - 3em) / 4 - 1px);
    }

    @include media-xxl-up {
      --carousel-slide-width: calc((100% - 4em) / 5 - 1px);
    }
  }

  .product-block {
    height: 100%;
  }
}
</style>
